import { render, staticRenderFns } from "./agreeUser.vue?vue&type=template&id=c9cfa732&scoped=true&"
import script from "./agreeUser.vue?vue&type=script&lang=js&"
export * from "./agreeUser.vue?vue&type=script&lang=js&"
import style0 from "./agreeUser.vue?vue&type=style&index=0&id=c9cfa732&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cfa732",
  null
  
)

export default component.exports